var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7276 5.06001C16.1181 5.45054 16.1181 6.0837 15.7276 6.47423L10.2018 12L15.7276 17.5258C16.1181 17.9163 16.1181 18.5495 15.7276 18.94C15.337 19.3305 14.7039 19.3305 14.3133 18.94L8.42407 13.0507C8.28617 12.9176 8.17495 12.7578 8.09804 12.58C8.09794 12.5798 8.09785 12.5796 8.09775 12.5793L9.01579 12.1829L8.09833 12.5807C8.09823 12.5805 8.09814 12.5802 8.09804 12.58C8.01849 12.3963 7.97791 12.1989 7.97791 12C7.97791 11.8009 8.01859 11.6032 8.09833 11.4193L9.01579 11.8171L8.09775 11.4206C8.17467 11.2426 8.28599 11.0826 8.42406 10.9493L8.41608 10.9573L9.12319 11.6644L8.43862 10.9354C8.43373 10.94 8.42888 10.9446 8.42406 10.9493L14.3133 5.06001C14.7039 4.66949 15.337 4.66949 15.7276 5.06001Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronLeft.1ac3a6d69d1f50e40aa4cd1d367922c0.svg";